import { City } from 'models/shared/types/city';

const getCity = (): City[] | null => {
	const city = localStorage.getItem('city');
	if (city) {
		return JSON.parse(city);
	}
	return null;
};

const setcity = (city: City[]) => {
	localStorage.setItem('city', JSON.stringify(city));
};

const clearCity = () => {
	localStorage.removeItem('city');
};

export { getCity, setcity, clearCity };
